const DYNAMIC_SENDER_UID_PREFIX = 'sg_';

/** A uid's key in the dynamic sender names lookup, which services trims and lowercases. */
export function dynamicSenderUidKey(sender: string): string {
  return sender.trim().toLowerCase();
}

/** Mirrors services `identities.IsDynamicSenderUID`. */
export function isDynamicSenderUid(sender: string): boolean {
  return dynamicSenderUidKey(sender).startsWith(DYNAMIC_SENDER_UID_PREFIX);
}
